import { v1 as uuid } from "uuid";
import AddressesContent, { DeliveryMethod } from "@Types/addresses";
import { Currency, Price, PriceFormatted as PriceApi } from "@Types/api/price";
import CartContent, {
  Article,
  Country,
  Icon,
  Place,
  Placeholders,
  ProductOption,
} from "@Types/cart";
import CreditCard from "@Types/creditCard";
import { PriceFormatted } from "@Types/price";
import Promo from "@Types/promos";

export const currency: Currency = "EUR";

export const articles: Article[] = [
  {
    additionalOptions: [
      {
        name: undefined,
        optionValueTag: "amount",
        productOptionTag: "amount",
        quantity: 10,
        tag: "amount",
        title: undefined,
        total: {
          cents: 1000,
          currency: "EUR",
          formattedPrice: "10 €",
        },
      },
    ],
    contentDeviceTag: "web_app",
    createdDate: "2021-07-30T20:05:54.299+02:00",
    currency: "EUR",
    customerImageUrl: undefined,
    gift: false,
    id: 60439146,
    pagesCount: 20,
    photoCount: 2,
    product: {
      articleBehaviorTag: "",
      deprecated: false,
      isKustomAvailableOnMobile: false,
      isQuantityUpdatable: true,
      kustomPageNamePlural: "page",
      kustomPageNameSingular: "pages",
      name: "Carte Cadeau",
      outOfStock: false,
      priceCents: 450,
      productImage: {
        big: "https://cdn2.chrzz.com/contents/assets/image-LTxNUusNdXRAAKQr1DmL9ZDc-3x-1.png",
        medium: "https://cdn2.chrzz.com/contents/assets/image-LTxNUusNdXRAAKQr1DmL9ZDc-2x-1.png",
        small: "https://cdn2.chrzz.com/contents/assets/image-LTxNUusNdXRAAKQr1DmL9ZDc-1x-1.png",
      },
      skipSelection: false,
      statProductGroupTag: "gift-cards",
      tag: "printable-gift",
    },
    quantity: 1,
    recovered: false,
    selectionContent: undefined,
    title: undefined,
    total: {
      cents: 1450,
      currency: "EUR",
      formattedPrice: "14,50 €",
    },
    updatedDate: "2021-07-30T20:05:54.349+02:00",
  },
  {
    additionalOptions: [],
    contentDeviceTag: "web_app",
    createdDate: "2021-07-30T20:04:15.015+02:00",
    currency: "EUR",
    customerImageUrl:
      "https://fotomk8s.cheerz.com/photos/b571222c8d41e561b1c9648581c8fa1eee414092.jpg",
    gift: false,
    id: 60439105,
    pagesCount: 20,
    photoCount: 1,
    product: {
      articleBehaviorTag: "skip_selection",
      deprecated: false,
      isKustomAvailableOnMobile: true,
      isQuantityUpdatable: true,
      kustomPageNamePlural: "page",
      kustomPageNameSingular: "pages",
      name: "Tirage photo rétro",
      outOfStock: false,
      priceCents: 700,
      productImage: {
        big: "https://cdn2.chrzz.com/contents/assets/image-mlo3cyb3l8m465j6ak1vi4j89ykg-3x-1.png",
        medium:
          "https://cdn2.chrzz.com/contents/assets/image-mlo3cyb3l8m465j6ak1vi4j89ykg-2x-1.png",
        small: "https://cdn2.chrzz.com/contents/assets/image-mlo3cyb3l8m465j6ak1vi4j89ykg-1x-1.png",
      },
      skipSelection: true,
      statProductGroupTag: "prints",

      tag: "print8x10-glossy-pack20",
    },
    quantity: 5,
    recovered: false,
    selectionContent: undefined,
    title: "Titre personnalisé",
    total: {
      cents: 3500,
      currency: "EUR",
      formattedPrice: "35 €",
    },
    updatedDate: "2021-07-30T20:04:53.273+02:00",
  },
];

export const cart: CartContent = {
  articles,
  currency,
  deliveryDates: ["2021-08-05T00:00:00.000+02:00", "2021-08-09T00:00:00.000+02:00"],
  freeShippingConfig: {
    amountUntilPromo: {
      cents: 50,
      currency: "EUR",
      formattedPrice: "0,50 €",
    },
    appliablePromo: false,
    promoCode: "WOW",
    promoCodeApplied: false,
    promoTriggerAmount: {
      cents: 5000,
      currency: "EUR",
      formattedPrice: "50 €",
    },
  },
  giftNote: {
    available: false,
    content: undefined,
  },

  lockedDuringPayment: false,
  orderNumber: "CZ0825496390",
  promoCode: undefined,
  promoTotal: { cents: 0, currency, formattedPrice: "0 €" },
  revenue: 4500,
  shippable: true,
  shippingOptions: {
    home: {
      express: {
        available: true,
        deliveryDates: undefined,
        price: {
          cents: 990,
          currency,
          formattedPrice: "9,90 €",
        },
        selected: false,
      },
      normal: {
        available: true,
        deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
        price: { cents: 450, currency, formattedPrice: "4,50 €" },
        selected: true,
      },
    },
    mondialRelay: {
      express: {
        available: false,
        deliveryDates: undefined,
        price: undefined,
        selected: false,
      },
      normal: {
        available: true,
        deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
        price: { cents: 450, currency, formattedPrice: "4,50 €" },
        selected: false,
      },
    },
  },
  shippingTotal: { cents: 450, currency, formattedPrice: "4,50 €" },
  subTotal: { cents: 4950, currency, formattedPrice: "49,50 €" },
  tax: 900,
  total: { cents: 5400, currency, formattedPrice: "54 €" },
};

export const productOptions: ProductOption[] = [
  {
    name: undefined,
    optionValueTag: "gift",
    productOptionTag: "bag",
    quantity: 1,
    tag: "gift",
    title: "Gift bag",
    total: { cents: 350, currency, formattedPrice: "3,50 €" },
  },
  {
    name: undefined,
    optionValueTag: "default",
    productOptionTag: "fairy_lights",
    quantity: 1,
    tag: "default",
    title: "LED Garland",
    total: { cents: 800, currency, formattedPrice: "8 €" },
  },
  {
    name: undefined,
    optionValueTag: "page",
    productOptionTag: "additional_pages",
    quantity: 1,
    tag: "page",
    title: undefined,
    total: { cents: 150, currency, formattedPrice: "1,50 €" },
  },
];

export const upsells: ProductOption[] = [
  {
    name: undefined,
    optionValueTag: "gift",
    productOptionTag: "bag",
    quantity: 1,
    tag: "gift",
    title: "Gift bag",
    total: { cents: 350, currency, formattedPrice: "3,50 €" },
  },
  {
    name: undefined,
    optionValueTag: "default",
    productOptionTag: "fairy_lights",
    quantity: 1,
    tag: "default",
    title: "LED Garland",
    total: { cents: 800, currency, formattedPrice: "8 €" },
  },
];

export const price: Price = { cents: 1100, currency };

export const formattedPriceApi: PriceApi = {
  cents: -1100,
  currency,
  formatted_price: "-11,00 €",
};

export const formattedPrice: PriceFormatted = { ...price, formattedPrice: "11,00 €" };

export const bannerTexts: string[] = [
  "Add 2 Calendars to your cart and get 15% discount with the code CALENDAR2",
  "15% off all products when you spend £80 or more",
  "Add 3 Calendars to your cart and get 20% discount with the code CALENDAR3",
];

export const promos: Promo[] = [
  {
    code: "CALENDAR2",
    description:
      "Ajoutez 2 calendriers à votre panier et bénéficiez de 15% de réduction avec le code CALENDAR2 😉 (hors frais de port)",
    priority: 4,
    title: "Pack 2 Calendriers",
  },
  {
    code: "CHEERZ80",
    description: "15% offerts sur le total de votre commande dès 80€ d'achat (hors frais de port)",
    priority: 2,
    title: "15% offerts",
  },
];

export const promoCode = "PROMOCODE";

export const promoCodeErrorMessage =
  "Code promo non valide, veuillez vérifier la date de validité et réessayer";

export const promoCodeApiErrorResponse = {
  error: {
    developer_message: "Error: developer message",
    error_code: "CFE-001",
    user_message: "Error: user message",
  },
};

// TODO: modify when you refacto the component which uses it

export const paymentLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/cb-6a812aa4.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/mastercard-f993d7d1.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/paypal-b5e6f4d0.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/visa-c66ca566.png",
];

export const packagingLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/gift-d4940111.png",
];

export const deliveryLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/dhl-ecd7a56f.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/yodel-28b52705.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/royal_air_mail-8c045ed2.png",
];

export const satisfactionGuaranteeLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/diduenjoy-418a3c2a.png",
];

export const countries: Country[] = [
  {
    name: "Andorra",
    tag: "AD",
    tagAlpha3: "AND",
  },
  {
    name: "Argentina",
    tag: "AR",
    tagAlpha3: "ARG",
  },
  {
    name: "Australia",
    tag: "AU",
    tagAlpha3: "AUS",
  },
  {
    name: "Austria",
    tag: "AT",
    tagAlpha3: "AUT",
  },
  {
    name: "Belgium",
    tag: "BE",
    tagAlpha3: "BEL",
  },
  {
    name: "Brazil",
    tag: "BR",
    tagAlpha3: "BRA",
  },
  {
    name: "Canada",
    tag: "CA",
    tagAlpha3: "CAN",
  },
  {
    name: "Chile",
    tag: "CL",
    tagAlpha3: "CHL",
  },
  {
    name: "China",
    tag: "CN",
    tagAlpha3: "CHN",
  },
  {
    name: "Colombia",
    tag: "CO",
    tagAlpha3: "COL",
  },
  {
    name: "Czech Republic",
    tag: "CZ",
    tagAlpha3: "CZE",
  },
  {
    name: "Denmark",
    tag: "DK",
    tagAlpha3: "DNK",
  },
  {
    name: "Estonia",
    tag: "EE",
    tagAlpha3: "EST",
  },
  {
    name: "Finland",
    tag: "FI",
    tagAlpha3: "FIN",
  },
  {
    name: "France",
    tag: "FR",
    tagAlpha3: "FRA",
  },
  {
    name: "Germany",
    tag: "DE",
    tagAlpha3: "DEU",
  },
  {
    name: "Greece",
    tag: "GR",
    tagAlpha3: "GRC",
  },
  {
    name: "Hong Kong",
    tag: "HK",
    tagAlpha3: "HKG",
  },
  {
    name: "Hungary",
    tag: "HU",
    tagAlpha3: "HUN",
  },
  {
    name: "Ireland",
    tag: "IE",
    tagAlpha3: "IRL",
  },
  {
    name: "Italy",
    tag: "IT",
    tagAlpha3: "ITA",
  },
  {
    name: "Luxembourg",
    tag: "LU",
    tagAlpha3: "LUX",
  },
  {
    name: "Malta",
    tag: "MT",
    tagAlpha3: "MLT",
  },
  {
    name: "Mexico",
    tag: "MX",
    tagAlpha3: "MEX",
  },
  {
    name: "Monaco",
    tag: "MC",
    tagAlpha3: "MCO",
  },
  {
    name: "Morocco",
    tag: "MA",
    tagAlpha3: "MAR",
  },
  {
    name: "Netherlands",
    tag: "NL",
    tagAlpha3: "NLD",
  },
  {
    name: "New Zealand",
    tag: "NZ",
    tagAlpha3: "NZL",
  },
  {
    name: "Norway",
    tag: "NO",
    tagAlpha3: "NOR",
  },
  {
    name: "Poland",
    tag: "PL",
    tagAlpha3: "POL",
  },
  {
    name: "Portugal",
    tag: "PT",
    tagAlpha3: "PRT",
  },
  {
    name: "Qatar",
    tag: "QA",
    tagAlpha3: "QAT",
  },
  {
    name: "Romania",
    tag: "RO",
    tagAlpha3: "ROU",
  },
  {
    name: "Singapore",
    tag: "SG",
    tagAlpha3: "SGP",
  },
  {
    name: "Slovakia",
    tag: "SK",
    tagAlpha3: "SVK",
  },
  {
    name: "Slovenia",
    tag: "SI",
    tagAlpha3: "SVN",
  },
  {
    name: "South Africa",
    tag: "ZA",
    tagAlpha3: "ZAF",
  },
  {
    name: "Spain",
    tag: "ES",
    tagAlpha3: "ESP",
  },
  {
    name: "Sweden",
    tag: "SE",
    tagAlpha3: "SWE",
  },
  {
    name: "Switzerland",
    tag: "CH",
    tagAlpha3: "CHE",
  },
  {
    name: "Thailand",
    tag: "TH",
    tagAlpha3: "THA",
  },
  {
    name: "Turkey",
    tag: "TR",
    tagAlpha3: "TUR",
  },
  {
    name: "United Arab Emirates",
    tag: "AE",
    tagAlpha3: "ARE",
  },
  {
    name: "United Kingdom",
    tag: "GB",
    tagAlpha3: "GBR",
  },
  {
    name: "United States",
    tag: "US",
    tagAlpha3: "USA",
  },
];

export const deliverAddressIcon: Icon = {
  description: "Delivery address",
  url: "https://cdn2.chrzz.com/assets/images/cart/checkout/icon-address-fad7b441.svg",
};

export const billingAddressIcon: Icon = {
  description: "Billing address",
  url: "https://cdn2.chrzz.com/assets/images/cart/checkout/icon-billing-dd530772.svg",
};

export const addresses: Place[] = [
  {
    fullName: "NC, USA",
    id: uuid(),
    placeName: "Asheville",
    value: "Asheville, NC, USA",
  },
  {
    fullName: "",
    id: uuid(),
    placeName: "Asia",
    value: "Asia",
  },
  {
    fullName: "CO, USA",
    id: uuid(),
    placeName: "Aspen",
    value: "Aspen, CO, USA",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
];

export const fakeAddresses: Place[] = [
  {
    fullName: "NC, USA",
    id: uuid(),
    placeName: "Asheville",
    value: "Asheville, NC, USA",
  },
  {
    fullName: "",
    id: uuid(),
    placeName: "Asia",
    value: "Asia",
  },
  {
    fullName: "CO, USA",
    id: uuid(),
    placeName: "Aspen",
    value: "Aspen, CO, USA",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
];

export const placeholders: Placeholders = {
  city: "City",
  company: "Company name (optional)",
  country: "Country",
  details: "Additional details (Apartment n°, entrance code..)",
  email: "Email",
  firstName: "First Name",
  lastName: "Last Name",
  phone: "Phone number",
  postcode: "Postcode",
  street: "Address (n° and street name)",
  tvaNumber: "TVA number (optional)",
};

export const address: AddressesContent = {
  billing: {
    city: "Paris",
    company: "Cheerz",
    country: "France",
    countryTag: "FRA",
    countryTag2: "FR",
    details: "4e étage",
    firstName: "Pierre",
    lastName: "Touron",
    postcode: "75008",
    state: undefined,
    street: "7 rue de bucarest",
    tvaNumber: "22222",
  },
  delivery: {
    city: "Paris",
    company: "Cheerz",
    country: "France",
    countryTag: "FRA",
    countryTag2: "FR",
    details: "4e étage",
    email: "pierre@cheerz.com",
    firstName: "Pierre",
    lastName: "Touron",
    mondialRelayNumber: "014050",
    phone: "0505050505",
    postcode: "75008",
    shippingOptions: {
      express: {
        available: true,
        deliveryDates: ["2019-12-19T12:00:00.000+01:00", "2019-12-20T12:00:00.000+01:00"],
        price: {
          cents: 990,
          currency: "EUR",
          formattedPrice: "9,90 €",
        },
        selected: false,
      },
      mondialRelay: {
        express: {
          available: false,
          deliveryDates: undefined,
          price: undefined,
          selected: false,
        },
        normal: {
          available: true,
          deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
          price: {
            cents: 390,
            currency: "EUR",
            formattedPrice: "3,90 €",
          },
          selected: false,
        },
      },
      normal: {
        available: true,
        deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
        price: {
          cents: 390,
          currency: "EUR",
          formattedPrice: "3,90 €",
        },
        selected: true,
      },
    },
    state: undefined,
    street: "7 rue de bucarest",
    tag: "home",
    userCountryTag: "FRA",
  },
  user: {
    temporaryEmail: "pierre@cheerz.com",
  },
};

export const shippingOptions = {
  home: {
    express: {
      available: true,
      deliveryDates: undefined,
      price: {
        cents: 990,
        currency,
        formattedPrice: "9,90 €",
      },
      selected: false,
    },
    normal: {
      available: true,
      deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
      price: {
        cents: 450,
        currency,
        formattedPrice: "4,50 €",
      },
      selected: true,
    },
  },
  mondialRelay: {
    express: {
      available: false,
      deliveryDates: undefined,
      price: undefined,
      selected: false,
    },
    normal: {
      available: true,
      deliveryDates: ["2021-08-05T12:00:00.000+02:00", "2021-08-09T12:00:00.000+02:00"],
      price: {
        cents: 450,
        currency,
        formattedPrice: "4,50 €",
      },
      selected: false,
    },
  },
};

export const deliveryMethods: DeliveryMethod[] = [
  {
    deliveryModes: shippingOptions.home,
    logo: "home_delivery.png",
    name: "home",
    selected: true,
  },
  {
    deliveryModes: shippingOptions.mondialRelay,
    logo: "mondial_relay.png",
    name: "mondialRelay",
    selected: false,
  },
];

export const creditCard: CreditCard = {
  cardType: "visa",
  identifier: "7500",
  month: 2,
  year: 2022,
};

export const deliveryDates = ["2019-12-23T00:00:00.000+01:00", "2019-12-24T00:00:00.000+01:00"];
